export default "__VITE_ASSET__EGHDzPYQ__"